exports = module.exports = require("../../../../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, "[data-v-47f29992] .el-card__body{height:100%}.evaluation-tree[data-v-47f29992]::-webkit-scrollbar{width:6px}.evaluation-tree[data-v-47f29992]  .el-tree-node__content{height:36px}", ""]);

// exports
